import { useMemo } from "react";
import { useRows } from "./db";

/** The current store's business installed_modules as a Set, live from core.businesses. `loading` until the row is read. */
export function useInstalledModules(businessId: string): { modules: Set<string>; loading: boolean } {
  const { data, isLoading } = useRows("businesses", "SELECT * FROM businesses WHERE id = ?", [businessId]);
  const modules = useMemo(() => new Set((data[0]?.installed_modules ?? []).filter((m) => m !== "")), [data]);
  // An empty answer just after the first sync is not "no modules": the business row is always there once it lands.
  return { modules, loading: isLoading || data.length === 0 };
}
